module.exports = __webpack_public_path__ + "media/components/outside-promo-page/static/menu-1b601e61558a43f67677d528160e52a2.svg";